
import { GeoLocationMessage } from './geoLocation';

import { Provider } from './providers';

import { mapEventProvider } from './mapEventProvider';

export default class FakeGeoLocationEngine extends Provider
{
    constructor(){
        super();
        this.handler = this.onMapClick.bind(this);
        this.intervalId = -1;
    }

    onMapClick(e){
        if(e.type == "click"){
            
            const coordinates = GeoLocationMessage.newCoords(e.coordinates);
            this._broadcastValue(coordinates);

            clearInterval(this.intervalId);
            this.intervalId = setInterval(() => {
                this._broadcastValue(coordinates);
            }, 5000);
        }
    }

    start() {
        console.log("start fake geolocation engine")
        mapEventProvider.addListener(this.handler);
    }

    stop() {
        console.log("stop fake geolocation engine")
        mapEventProvider.removeListener(this.handler);
    }

    publishCoords(coords) {
        this._broadcastValue(GeoLocationMessage.newCoords(coords));
    }
}
